<template>
  <div v-if="isEnabledLocation">
    <v-skeleton-loader
      v-if="api.loading || formattedWeather.length < 3"
      ref="skeleton"
      :boilerplate="false"
      type="list-item-avatar-three-line"
      :tile="true"
      max-width="600"
      max-height="300"
    />
    <div v-else>
      <span class="font-weight-bold title d-block mb-4">
        Current Conditions
      </span>
      <v-card class="pa-8">
        <v-row>
          <v-col sm="12" md="6" lg="4">
            <div class="weather-main">
              <v-list three-line class="pa-0 px-9 px-sm-0">
                <v-list-item class="align-md-center justify-center pa-0">
                  <v-list-item-avatar class="align-self-center mr-4" size="50">
                    <img
                      :src="
                        require(`@assets/images/weather/${formattedWeather[0].icon}.svg`)
                      "
                      :alt="formattedWeather[0].summary"
                    />
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title
                      class="display-3  font-weight-regular letter-spacing-normal"
                    >
                      {{ formattedWeather[0].temp.currency(2) }}
                      <sup>o</sup>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-row class="d-sm-flex justify-space-between px-4 mt-10">
                <div
                  v-for="(weather, index) in formattedWeather.slice(
                    1,
                    formattedWeather.length
                  )"
                  :key="index"
                  class="weather-list text-center align-center justify-center flex-column"
                >
                  <img
                    :src="require(`@assets/images/weather/${weather.icon}.svg`)"
                    :alt="weather.summary"
                    height="26"
                  />
                  <span
                    class="d-block font-weight-bold body-2 text-transform-uppercase text-center"
                  >
                    {{ weather.dayOfWeek }}
                  </span>
                </div>
              </v-row>
            </div>
          </v-col>
          <v-col lg="1" class="d-sm-none d-md-block">
            <v-divider class="mx-8" :vertical="true" />
          </v-col>
          <v-col sm="12" class="d-md-none">
            <v-divider class="mx-8" />
          </v-col>
          <v-col>
            <div class="weather-secondary">
              <div
                class="weather-secondary-list d-sm-flex d-md-block justify-space-between"
              >
                <div
                  class="weather-secondary-list--item d-flex flex-column mb-4"
                >
                  <h3 class="body-2 grey--text lighten-2 font-weight-bold">
                    Precipitation
                  </h3>
                  <div class="d-flex">
                    <img
                      :src="require('@assets/images/weather/umbrella.svg')"
                      alt="Precipitation"
                      class="mr-3"
                      width="17"
                    />
                    <span class="body-1 font-weight-bold letter-spacing-normal">
                      {{ formattedWeather[0].precipitation.currency(2) }}%
                    </span>
                  </div>
                </div>
                <div
                  class="weather-secondary-list--item d-flex flex-column mb-4"
                >
                  <h3 class="body-2 grey--text lighten-2 font-weight-bold">
                    Wind Speed
                  </h3>
                  <div class="d-flex">
                    <img
                      :src="require('@assets/images/weather/wind-black.svg')"
                      alt="wind"
                      class="mr-3"
                      width="17"
                    />
                    <span class="body-1 font-weight-bold letter-spacing-normal">
                      {{ formattedWeather[0].wind.speed.currency() }}
                    </span>
                  </div>
                </div>
                <div
                  class="weather-secondary-list--item d-flex flex-column mb-4"
                >
                  <h3 class="body-2 grey--text lighten-2 font-weight-bold">
                    Sea Temperature
                  </h3>
                  <div class="d-flex">
                    <img
                      :src="require('@assets/images/weather/temperature.svg')"
                      alt="Precipitation"
                      class="mr-3"
                      width="17"
                      height="24"
                    />
                    <span class="body-1 font-weight-bold letter-spacing-normal">
                      0%
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <!--        <div class="d-flex"></div>-->
      </v-card>
    </div>
  </div>
</template>

<script>
import { WeatherAPI, Weather } from '@models/Weather';
export default {
  name: 'Weather',
  data() {
    return {
      weathers: {},
      user: this.$store.state.auth.user,
      api: new WeatherAPI(),
      enabledLocation: false,
    };
  },
  computed: {
    formattedWeather() {
      let self = this;
      let weathers = Object.values(self.weathers);
      if (!weathers.length) {
        return [];
      }
      return weathers.slice(0, 4).map((singleDay) => {
        return new Weather(singleDay);
      });
    },
    isEnabledLocation() {
      return this.enabledLocation;
    },
  },
  methods: {
    fetchWeather() {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          this.weathers = await this.api.get({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          this.enabledLocation = true;
        },
        (error) => {
          this.enabledLocation = false;
          console.error(error.message);
        }
      );
    },
  },
  mounted() {
    this.fetchWeather();
  },
};
</script>

<style scoped></style>
